import * as appConfig from './../app.config';
import { AppointmentsComponent } from '../components/appointments/appointments.component';
import { CalendarDetailComponent } from '../components/appointments/calendar-detail.component';
import { AppointmentsOverviewComponent } from '../components/appointments/appointments-overview.component';
import { AppointmentsWindowComponent } from '../components/appointments/appointments-window.component';
import { AppointmentHolidayDetailComponent } from '../components/appointments/appointment-holiday-detail.component';
import { ConfirmationComponent } from '../shared/components/modal/confirmation/confirmation.component';

const defaultRoute = {
  path: 'appointments',
  redirectTo: 'novelties'
};

const activeModuleRoutes = {
  path: 'appointments',
  data: {
    breadcrumbs: {
      label: 'Kalendáře',
      icon: 'booking'
    },
    state: 'appointments'
  },
  children: [
    {
      path: '',
      component: AppointmentsComponent
    },
    {
      path: 'add',
      data: {
        breadcrumbs: {
          label: 'Přidat kalendář'
        },
        state: 'calendar-add'
      },
      children: [
        {
          path: '',
          component: CalendarDetailComponent
        }
      ]
    },
    {
      path: 'edit/:id',
      data: {
        breadcrumbs: {
          label: 'Upravit kalendář'
        },
        state: 'calendar-edit'
      },
      children: [
        {
          path: '',
          component: CalendarDetailComponent
        }
      ]
    },
    {
      path: 'calendar/:id',
      data: {
        breadcrumbs: {
          label: 'Kalendáře'
        },
        state: 'appointments-calendar'
      },
      children: [
        {
          path: '',
          component: AppointmentsOverviewComponent
        },
        {
          path: ':day/:from/:interval',
          component: AppointmentsWindowComponent,
          data: {
            breadcrumbs: {
              label: 'Upravit blok schůzek'
            },
            state: 'appointment-edit'
          },
          outlet: 'modal'
        }
      ]
    },
    {
      path: 'holidays/add',
      data: {
        breadcrumbs: {
          label: 'Přidat volno'
        },
        state: 'holiday-add'
      },
      children: [
        {
          path: '',
          component: AppointmentHolidayDetailComponent
        }
      ]
    },
    {
      path: 'holidays/edit/:id',
      data: {
        breadcrumbs: {
          label: 'Upravit volno'
        },
        state: 'holiday-edit'
      },
      children: [
        {
          path: '',
          component: AppointmentHolidayDetailComponent
        }
      ]
    },
    {
      path: 'holidays/add/:calendar_id',
      data: {
        breadcrumbs: {
          label: 'Přidat volno'
        },
        state: 'holiday-add'
      },
      children: [
        {
          path: '',
          component: AppointmentHolidayDetailComponent
        }
      ]
    },
    {
      path: 'delete/:id',
      component: ConfirmationComponent,
      data: {
        breadcrumbs: {
          label: 'Smazat kalendář'
        },
        state: 'appointment-calendars-delete',
        apiUri: 'appointment-calendars'
      },
      outlet: 'modal'
    },

    {
      path: 'holidays-delete/:id',
      component: ConfirmationComponent,
      data: {
        breadcrumbs: {
          label: 'Smazat kalendář'
        },
        state: 'appointment-holidays-delete',
        apiUri: 'appointment-calendar-holidays'
      },
      outlet: 'modal'
    }
  ]
};

export const appointmentRoutes = appConfig.modules.appointments ? activeModuleRoutes : defaultRoute;
